class noDeductionReasonCtrl {
  constructor(
    $scope,
    $uibModalInstance,
    items1,
    httpRequest,
    logger,
    formvalidateApi
  ) {
    console.log(items1);
    $scope.invoiceAccountIdList = items1.invoiceAccountIdList;
    $scope.billIdList = items1.billIdList;
    $scope.param = {
      notDeductionReason: '3',
    };
    $scope.dictData = items1.dictData;
    // 校验
    $scope.validateRules = {
      noDeductionReason: [
        {
          erromsg: '必填项',
          condition(value) {
            // 规则
            // true 标示显示 errmsg  false 标示验证通过
            return !value;
          },
        },
      ],
    };
    $scope.cancel = () => {
      $uibModalInstance.close();
    };
    $scope.ok = () => {
      const mark = formvalidateApi.run();
      if (!mark) {
        return;
      }
      const { notDeductionReason } = $scope.param;
      let param = [];
      if(!$scope.billIdList[0]){
        $scope.invoiceAccountIdList.forEach((item) => {
            param.push({ invoiceAccountId: item, notDeductionReason });
          });
      }else{
        $scope.billIdList.forEach((item) => {
            param.push({ billId: item, notDeductionReason });
          });
      }
      httpRequest
        .post_updateNoDeductionReason(param, '批量操作成功')
        .then((res) => {
          $uibModalInstance.close();
        });
    };
  }
}

noDeductionReasonCtrl.$inject = [
  '$scope',
  '$uibModalInstance',
  'items1',
  'httpRequest',
  'logger',
  'formvalidateApi',
];
export default noDeductionReasonCtrl;



// WEBPACK FOOTER //
// ./src/components/deductionCheck/noDeductionReasonCtrl.js